import SEO from '../components/SEO';
import { HeroSection } from './home/HeroSection';
import { HowItWorksSection } from './home/HowItWorksSection';
import { InfraMapSection } from './home/InfraMapSection';
import {
  TrustSection, ProductsSection, SecuritySection, ManagedCloudSection,
  SolutionsPreviewSection, WhyDaakyiSection, RegionProofSection,
  PricingFrameworkSection, DeveloperSection, TrustCTASection, CTASection
} from './home/Sections';
import { CompareTeaserSection } from './home/CompareTeaserSection';
import { ShapeDivider } from '../components/ShapeDivider';
import { Link } from 'react-router-dom';

const PhotoBand = () => (
  <section className="relative overflow-hidden" data-testid="photo-band">
    <img
      src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Accra_Skyline.jpg/1280px-Accra_Skyline.jpg"
      alt="Accra, Ghana business district skyline" loading="lazy"
      className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-[#120836]/[0.72]" />
    <div className="relative z-10 max-w-[1200px] mx-auto px-6 lg:px-10 py-24 lg:py-32">
      <p className="text-[#F29B3D] text-xs font-bold uppercase tracking-[0.2em] mb-5">Accra, Ghana — Flagship Region</p>
      <h2 className="text-white font-extrabold tracking-[-0.03em] leading-[1.1] text-3xl sm:text-4xl lg:text-5xl max-w-3xl mb-6">
        Operated from Accra. Present on three continents.
      </h2>
      <p className="text-[#CBD5E1] text-lg max-w-xl mb-9">
        Our engineers design, run and secure the platform from West Africa — with offices in
        Houston and Dubai connecting African workloads to global markets.
      </p>
      <Link to="/about" data-testid="photo-band-cta" className="btn-primary inline-flex items-center">Meet DAAKYI</Link>
    </div>
  </section>
);

const StatementBand = () => (
  <section className="py-20 lg:py-28 bg-white" data-testid="statement-band">
    <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
      <p className="text-[#A8631A] text-xs font-bold uppercase tracking-[0.2em] mb-6">The DAAKYI Difference</p>
      <p className="text-[#1A1240] font-extrabold tracking-[-0.03em] leading-[1.12] text-3xl sm:text-4xl lg:text-[46px] max-w-4xl">
        One platform. Any jurisdiction. Shared sovereign cloud from West Africa — or a
        dedicated stack inside your borders, operated to the same standard.
      </p>
      <div className="mt-10 flex flex-wrap gap-4">
        <Link to="/platform" data-testid="statement-platform-cta" className="btn-primary">How the platform works</Link>
        <Link to="/regions" data-testid="statement-regions-cta" className="btn-glass">Regions &amp; sovereign sites</Link>
      </div>
    </div>
  </section>
);

const HREFLANG_ALTERNATES = [
  { hrefLang: 'en', path: '/' },
  { hrefLang: 'fr', path: '/fr' },
  { hrefLang: 'x-default', path: '/' }
];

export const Home = () => (
  <main data-testid="home-page">
    <SEO
      title="Secure African Cloud Infrastructure"
      description="DAAKYI Cloud provides secure compute, storage, networking, backup, cloud security, and managed cloud services powered by enterprise cloud technology in Ghana."
      path="/" image="/og/home.jpg"
      alternates={HREFLANG_ALTERNATES}
    />
    <HeroSection />
    <ShapeDivider fill="#120836" bg="#FFFFFF" />
    <TrustSection />
    <ProductsSection />
    <HowItWorksSection />
    <StatementBand />
    <PhotoBand />
    <WhyDaakyiSection />
    <ShapeDivider fill="#120836" bg="#FFFFFF" flip />
    <SecuritySection />
    <ShapeDivider fill="#120836" bg="#F8FAFC" />
    <ManagedCloudSection />
    <SolutionsPreviewSection />
    <RegionProofSection />
    <ShapeDivider fill="#120836" bg="#F8FAFC" flip />
    <InfraMapSection />
    <ShapeDivider fill="#120836" bg="#F8FAFC" />
    <PricingFrameworkSection />
    <CompareTeaserSection />
    <ShapeDivider fill="#120836" bg="#F8FAFC" flip />
    <DeveloperSection />
    <ShapeDivider fill="#120836" bg="#FFFFFF" />
    <TrustCTASection />
    <ShapeDivider fill="#120836" bg="#FFFFFF" flip />
    <CTASection />
  </main>
);

export default Home;
